export const classes = {
  button: ["width30", "bold", "italic", "inlineBlock", "letterSpacing015"]
}
